module.exports = __webpack_public_path__ + "static/media/Arrow right.5ef79669.svg";